import React from 'react'
import Top from '../../components/common/Top'
import Lefter from '../../components/common/Lefter'
import ContractInfo from '../../components/common/ContractInfo'
import Apply from '../../components/common/Apply'
import CommonUploads from '../../components/common/Uploads/commonUploads'
import { Breadcrumb, Layout, Empty, Card, Col, Row, Tabs, Avatar, message, Modal, Form, Input, Button, Popconfirm, Spin, Divider } from 'antd';
import { AntDesignOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import actionWays from '../../redux/actions';
import Footer from '../../components/common/Footer'
import moment from 'moment';
import { getCancelReserve, getCancelQueue, getMyTransactionLists, getMyQueueLists, getUpdateUser, checkCaptcha, forgetPassword, getMyReserveLists, getUserBillLists, getMyContracts, getTransactionDetailById, getCollectProjects, getMessages, sendNationCaptcha, getContractInfo, printTransaction, repairMaterials } from '../../utils/api'
import { idCardValid, isPassPortCard, isTWCard } from "../../config/identityCheck";
const { TabPane } = Tabs;
const { Content } = Layout;

class Personal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionList: [],
            currest: '0',
            isedit: false,
            isChangeMobile: false,
            timer: 60,
            confirmLoading: false,
            visible: false,
            sonObj: {
                son: '0',
                transactionDetail: []
            },
            tapIndex: 0,
            loadings: false,
            isMaterial: false,
            loading: false,
            loadingss: true,
            isTap: false,
            commonArr: [{ kind: '居住证', content: "", thumbnail: "", transactionAdditionType: '主申请人附件', operator: '', lackMaterialsFlag: '2', createTime: '', id: '', transactionId: '', transactionLivingHouseId: '', transactionPersonId: '' }, { kind: '社保缴纳证明', content: "", thumbnail: "", transactionAdditionType: '主申请人附件', operator: '', lackMaterialsFlag: '2', createTime: '', id: '', transactionId: '', transactionLivingHouseId: '', transactionPersonId: '' }]
        }
        this.timers = null
    }
    componentDidMount() {
        let typeTab = '0'
        console.log(this.props.history.location.query)
        if (this.props.history.location) {
            if (this.props.history.location.query) {
                this.setState({
                    selectableTab: this.props.history.location.query.tab
                })
                if (this.props.history.location.query.tab) {
                    typeTab = '1'
                    this.getMyTransactionList(this.props.history.location.query.tab)
                }
            }
        }
        console.log(typeTab)
        if (typeTab == '0') {
            this.getMyTransactionList('0')
        }
    }
    getMyTransactionList = async (value) => {
        console.log(value)
        this.setState({
            selectableTab: value
        })
        if (value === '0') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            let data = await getMyTransactionLists('')
            if (data.code === 0) {
                let transactionList = data.data
                transactionList.forEach((item, index, data) => {
                    item.tapIndex = index
                    item.title = '受理编号\xa0\xa0' + (item.transactionNo ? item.transactionNo : '暂无受理编号') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0有效期限\xa0\xa0' + (item.transactionValidStart ? moment(item.transactionValidStart).format('LL') : '暂无开始日期') + '\xa0\xa0-\xa0\xa0' + (item.transactionValidEnd ? moment(item.transactionValidEnd).format('LL') : '暂无结束日期')
                    item.transactionNoTitle = '受理编号'
                    item.transactionNo = item.transactionNo ? item.transactionNo : '暂无受理编号'
                    item.timesTitle = '有效期限'
                    item.times = (item.transactionValidStart ? moment(item.transactionValidStart).format('YYYY/MM/DD') : '暂无开始日期') + '—' + (item.transactionValidEnd ? moment(item.transactionValidEnd).format('YYYY/MM/DD') : '暂无结束日期')
                    if (item.lackMaterialsReason) {
                        this.setState({
                            lackMaterialsReason: item.lackMaterialsReason
                        })
                    }
                })
                this.setState({
                    transactionList: transactionList,
                })
            }
        } else if (value === '1') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            let data = await getMyQueueLists('')

            if (data.code === 0) {
                let transactionList = data.data
                transactionList.forEach((item, index, data) => {
                    item.title = '提交时间\xa0\xa0' + (item.queueTime ? moment(item.queueTime).format('LL') : '暂无')
                    item.timesTitle = '提交时间'
                    item.times = (item.queueTime ? moment(item.queueTime).format('YYYY/MM/DD h:mm:ss') : '暂无开始日期')
                })
                this.setState({
                    transactionList: transactionList,
                })
            }
        }
        else if (value === '2') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            let data = await getMyReserveLists('')
            if (data.code === 0) {
                let transactionList = data.data
                transactionList.forEach((item, index, data) => {
                    item.title = '提交时间\xa0\xa0' + (item.reserveTime ? moment(item.reserveTime).format('LL') : '暂无')
                    item.timesTitle = '提交时间'
                    item.times = (item.reserveTime ? moment(item.reserveTime).format('YYYY/MM/DD h:mm:ss') : '暂无开始日期')
                })
                this.setState({
                    transactionList: transactionList,
                })
            }
        }
        else if (value === '3') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            opts.cardNo = this.props.userLoginInfo.idno
            opts.billStatus = '0'
            opts.pageIndex = '0'
            opts.pageSize = '20'
            let data = await getUserBillLists(opts)

            if (data.code === 0) {

                let transactionList = data.data.pageContent
                transactionList.forEach((item, index, data) => {
                    item.title = '应付日期\xa0\xa0' + (item.collectionPeriod ? item.collectionPeriod : '暂无') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0账单周期\xa0\xa0' + (item.billStartTime ? item.billStartTime : '暂无开始日期') + '\xa0\xa0-\xa0\xa0' + (item.billEndTime ? item.billEndTime : '暂无结束日期')
                    item.copeWithTitle = '应付日期'
                    item.copeWith = (item.collectionPeriod ? item.collectionPeriod : '暂无开始日期')
                    item.timesTitle = '账单周期'
                    item.times = (item.billStartTime ? moment(item.billStartTime).format('YYYY/MM/DD') : '暂无开始日期') + '—' + (item.billEndTime ? moment(item.billEndTime).format('YYYY/MM/DD') : '暂无结束日期')
                })
                this.setState({
                    transactionList: transactionList,
                })
            }
        }
        else if (value === '4') {

            let data = await getMyContracts('')
            if (data.code === 0) {
                let transactionList = data.data
                transactionList.forEach((item, index, data) => {
                    item.title = '合同号\xa0\xa0' + (item.contractNo ? item.contractNo : '暂无') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0合同周期\xa0\xa0' + (item.contractStartDate ? moment(item.contractStartDate).format('LL') : '暂无开始日期') + '\xa0\xa0-\xa0\xa0' + (item.contractEndDate ? moment(item.contractEndDate).format('LL') : '暂无结束日期')
                    item.contractNoTitle = '合同号码'
                    item.contractNo = item.contractNo ? item.contractNo : '暂无'
                    item.timesTitle = '合同周期'
                    item.times = (item.contractStartDate ? moment(item.contractStartDate).format('YYYY/MM/DD') : '暂无开始日期') + '—' + (item.contractEndDate ? moment(item.contractEndDate).format('YYYY/MM/DD') : '暂无结束日期')
                })
                this.setState({
                    transactionList: transactionList,
                })
            }
        }
        //我的收藏打开后续 value+1
        // else if (value === '5') {
        //     let opts = {}
        //     opts.projectNo = this.props.userLoginInfo.projectNo ? this.props.userLoginInfo.projectNo : ''
        //     opts.userId = this.props.userLoginInfo.id
        //     let data = await getCollectProjects(opts)
        //     if (data.code === 0) {
        //         if (!!data.data) {
        //             let transactionList = data.data
        //             this.setState({
        //                 transactionList: transactionList,
        //             })
        //         }

        //     }
        // }
        else if (value === '5') {
            let opts = {}
            opts.userId = this.props.userLoginInfo.id
            opts.status = '2'
            opts.pageIndex = '0'
            opts.pageSize = '20'
            let data = await getMessages(opts)
            if (data.code === 0) {
                if (!!data.data) {
                    let transactionList = data.data.pageContent

                    this.setState({
                        transactionList: transactionList,
                    })
                }

            }
        } else {
            console.log('this.props.userLoginInfo', this.props.userLoginInfo);
            this.setState({
                transactionList: [this.props.userLoginInfo],
            })
        }
        this.setState({
            currest: value,
            sonObj: {
                son: '0'
            }
        })
    }
    // 重设密码
    setPassword = async (value) => {
        const opts = {}
        opts.captcha = value.research
        opts.mobile = value.mobile
        let list = await checkCaptcha(opts)
        if (list.code === 0) {
            clearInterval(this.timers)
            let objs = {}
            objs.mobile = value.mobile
            objs.loginPwd = value.loginPwd
            objs.code = value.research
            let data = await forgetPassword(objs)
            if (data.code === 0) {
                message.success('密码修改成功')
                this.closePassword()
                this.setState({
                    timer: 60
                })
                this.props.saveLoginInfo(null);
                setTimeout(() => {
                    this.setState({
                        loginLoading: false,
                        personal: '0'
                    })
                })
            } else {
                message.error(data.message)
            }
        } else {
            message.error('验证码不可使用')
        }
    }
    closePassword = () => {
        this.setState({
            isModalVisible: true,
            isChangePassword: false
        })
    }
    callback = (e) => {
        let opts = {}
        opts.userId = this.props.userLoginInfo.id
        opts.cardNo = this.props.userLoginInfo.idno
        opts.billStatus = e
        opts.pageIndex = '0'
        opts.pageSize = '20'
        let data = getUserBillLists(opts)
        data.then(res => {
            if (res.code === 0) {
                let transactionList = res.data.pageContent
                if (Object.keys(transactionList).length > 0) {
                    transactionList.forEach((item, index, data) => {
                        item.title = '应付日期\xa0\xa0' + (item.collectionPeriod ? item.collectionPeriod : '暂无') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0账单周期\xa0\xa0' + (item.billStartTime ? item.billStartTime : '暂无开始日期') + '\xa0\xa0-\xa0\xa0' + (item.billEndTime ? item.billEndTime : '暂无结束日期')
                        item.copeWithTitle = '应付日期'
                        item.copeWith = (item.collectionPeriod ? item.collectionPeriod : '暂无开始日期')
                        item.timesTitle = '账单周期'
                        item.times = (item.billStartTime ? moment(item.billStartTime).format('YYYY/MM/DD') : '暂无开始日期') + '—' + (item.billEndTime ? moment(item.billEndTime).format('YYYY/MM/DD') : '暂无结束日期')
                    })
                }
                this.setState({
                    transactionList: transactionList,
                })
            }
        })
    }
    handleCancels = () => {
        this.setState({
            visible: false
        })
    }
    handleOk = async (id) => {
        this.setState({
            confirmLoading: true
        })
        const _self = this
        const data = await getCancelQueue({ id: id })
        if (data.code == 0) {
            _self.getMyTransactionList('1')
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
        this.setState({
            confirmLoading: false,
            visible: false
        })
        console.log(data)
    }
    cancelReserve = async (id) => {
        this.setState({
            confirmLoading: true
        })
        const _self = this
        const data = await getCancelReserve({ id: id })
        if (data.code == 0) {
            _self.getMyTransactionList('2')
            message.success('操作成功')
        } else {
            message.error(data.message)
        }
        this.setState({
            confirmLoading: false,
            visible: false
        })
        console.log(data)
    }
    showPopconfirm = () => {
        this.setState({
            visible: true
        })
    }
    showContractInfo = (contractNo) => {
        this.setState({
            sonObj: {
                son: '1'
            },
            loadings: true
        })
        this.contractInfo(contractNo)
    }
    contractInfo = async (contractNo) => {
        let opts = {
            contractNo: contractNo
        }
        let data = await getContractInfo(opts)
        if (data.code == 0) {
            let contractInfos = data.data
            console.log(contractInfos);
            this.setState({
                sonObj: {
                    son: '1',
                    contractInfos: contractInfos
                }
            }, () => {
                this.setState({
                    loadings: false
                })
            })
        }
    }
    showApply = (id) => {
        this.setState({
            sonObj: {
                son: '2'
            },
            loadings: true
        })
        this.transactionDetailById(id)

    }
    transactionDetailById = async (id) => {
        let opts = {
            id: id
        }
        let data = await getTransactionDetailById(opts)
        if (data.code == 0) {
            let transactionDetail = data.data
            console.log(transactionDetail);
            this.setState({
                sonObj: {
                    son: '2',
                    transactionDetail: transactionDetail
                }
            }, () => {
                this.setState({
                    loadings: false
                })
            })
        }
    }
    printTransaction = (item) => {
        let id = item.id
        let registeredAddress = ''
        console.log(item);
        // {transactionDetail.province}{transactionDetail.city}{transactionDetail.district}{transactionDetail.registeredAddress}
        // JSON.parse(transactionDetail.province)}{transactionDetail.registeredAddress
        if (item.city) {
            registeredAddress = (item.province ? item.province : '') + item.city + item.district + item.registeredAddress
        } else {
            // registeredAddress = item.province ? JSON.parse(item.province)[0] + JSON.parse(item.province)[1] + item.registeredAddress : item.registeredAddress
            registeredAddress = (item.province ? JSON.parse(item.province).join("") : '') + item.registeredAddress
        }
        console.log(registeredAddress);
        this.getPrintTransaction(id, registeredAddress)
    }
    getPrintTransaction = async (id, registeredAddress) => {
        // console.log(id);
        // console.log(registeredAddress);
        let opts = {
            id: id,
            registeredAddress: registeredAddress
        }
        let data = await printTransaction(opts)
        if (data.code == 0) {
            console.log(data.data);
            window.open(data.data)
        }
    }
    getProjectDetail = (p) => {
        let projectName = p.projectName, projectNo = p.projectNo
        this.props.history.push({ pathname: '/belows', query: { projectName: projectName, projectNo: projectNo } })
    }
    getChangeSon = (son) => {
        this.setState({
            sonObj: {
                son: son
            }
        })
    }
    getChangeSons = (son) => {
        this.setState({
            sonObj: {
                son: son
            }
        })
    }
    setCommonImages = (img, list, imgTmp) => {
        console.log(img);
        console.log(list);
        console.log(this.state.jzzList);
        console.log("this.state.sbList", this.state.sbList);
        img = img.toString()
        const { commonArr, jzzList, sbList } = this.state
        if (list.kind == '居住证') {
            commonArr[0].content = img.toString()
            commonArr[0].thumbnail = imgTmp.toString()
            commonArr[0].createTime = jzzList.createTime
            commonArr[0].id = jzzList.id
            commonArr[0].transactionId = jzzList.transactionId
            commonArr[0].transactionLivingHouseId = jzzList.transactionLivingHouseId
            commonArr[0].transactionPersonId = jzzList.transactionPersonId
        }
        if (list.kind == '社保缴纳证明') {
            commonArr[1].content = img.toString()
            commonArr[1].thumbnail = imgTmp.toString()
            commonArr[1].createTime = sbList.createTime
            commonArr[1].id = sbList.id
            commonArr[1].transactionId = sbList.transactionId
            commonArr[1].transactionLivingHouseId = sbList.transactionLivingHouseId
            commonArr[1].transactionPersonId = sbList.transactionPersonId
        }
        this.setState({
            commonArr: commonArr
        })
        console.log(this.state.commonArr);
        this.setState({
            jzImages: img
        })
    }
    repairMaterials = async () => {
        const { commonArr } = this.state
        console.log("🚀 ~ file: index.js:460 ~ Personal ~ repairMaterials= ~ this.state:", this.state)
        console.log(commonArr);
        let arr = []
        for (let i in commonArr) {
            commonArr[i].operator = this.props.userLoginInfo.idno
            // , createTime: '', id: '', transactionId: '', transactionLivingHouseId: '', transactionPersonId: ''
        }
        if (this.state.lackMaterialsFlag == '1') {
            arr.push(commonArr[0])
        }
        if (this.state.lackMaterialsFlag == '2') {
            arr.push(commonArr[1])
            if (arr[0].content == "" ) {
                message.error("请全部上传");
                return;
            }
        }
        if (this.state.lackMaterialsFlag == '3') {
            arr.push(commonArr[0])
            arr.push(commonArr[1])
            if (arr[0].content == "" && arr[1].content == "") {
            message.error("请全部上传");
            return;
            }
            
        }
        console.log(
          "🚀 ~ file: index.js:492 ~ Personal ~ repairMaterials= ~ arr:",
          arr
        );
        console.log("🚀 ~ file: index.js:483 ~ Personal ~ repairMaterials= ~ arr:", arr)
        // return;
        let data = await repairMaterials(arr)
        if (data?.code == 0) {
            message.success('上传成功')
            console.log(data.data);
            this.getMyTransactionList('0')
            this.setState({
                isMaterial: false
            })
        }else{
            message.error(data?.message)
        }
    }
    showMaterialMakeupBox = async (item) => {
        let id = item.id
        let lackMaterialsFlag = item.lackMaterialsFlag
        console.log(this.props.userLoginInfo.idno);
        this.setState({
            isMaterial: true,
            loadingss: false,
            lackMaterialsFlag: lackMaterialsFlag
        })
        let opts = {
            id: id
        }
        let data = await getTransactionDetailById(opts)
        if (data.code == 0) {
            console.log(data.data);
            if (data.data.transactionAdditionList) {
                data.data.transactionAdditionList.map((item, index) => {
                    if (item.kind == '居住证') {
                        console.log(item.content);
                        this.setState({
                            jzzList: item,
                            jzzImages: item.content,
                            jzzImagesTmp: item.thumbnail
                        })
                    }
                    if (item.kind == '社保缴纳证明') {
                        this.setState({
                            sbList: item,
                            sbImages: item.content,
                            sbImagesTmp: item.thumbnail
                        })
                    }
                })
            }
            // console.log(this.state.jzhImages);
        }
        setTimeout(() => {
            this.setState({
                loadingss: true
            })
        }, 100)
    }
    getTransactionDetailByIds = (id) => {
        this.props.history.push({ pathname: '/areatoraise', query: { id: id, type: '修改' } })
    }

    //资格证、排队、预约、支付、合同
    tableBody = (item, index) => {

        const contractStatus = (e) => {
            switch (e) {
                case 1:
                    return '预签'
                    break;
                case 2:
                    return '签约'
                    break;
                case 21:
                    return '在租'
                    break;
                case 3:
                    return '退房'
                    break;
                case 30:
                    return '退房审核'
                    break;
                case 31:
                    return '退款'
                    break;
                case 32:
                    return '退款'
                    break;
                case 33:
                    return '退款'
                    break;
                case 34:
                    return '退款'
                    break;
                case 35:
                    return '退款'
                    break;
                case 36:
                    return '退款'
                    break;
                case 37:
                    return '退款'
                    break;
                case 4:
                    return '完结'
                    break;
                case 50:
                    return '申续申请'
                    break;
                case 5:
                    return '完结'
                    break;
                case 44:
                    return '删除'
                    break;
            }
        }
        const { currest } = this.state
        const colorList = ['lv', 'hei', 'hui']
        const dt_1 = ['资格证申请', '小区名称', '小区名称', '小区名称', '小区名称']
        const dt_2 = ['申请类型', '户型意向', '房号', '房号', '房号']
        const dt_3 = ['申请属性', '排队名次', '预约时间', '应付金额', '合同属性']
        const dt_4 = [{
            key: item.checkStatus === '驳回' ? '已驳回' : item.progress,
            color: item.progress === '成功' ? 'lv' : item.progress === '失败' ? 'hui' : 'hei',
            dt_1: item.firstApply === '1' ? '首次申请' : item.firstApply === '0' ? '复核' : '暂无数据',
            dt_2: item.applyType ? item.applyType : '暂无数据',
            dt_3: item.applyAttruble ? item.applyAttruble : '暂无数据',
        }, {
            key: item.status,
            color: item.status === '排队成功' ? 'lv' : item.status === '排队中' ? 'hei' : 'hui',
            dt_1: item.projectName,
            dt_2: item.houseType + '室户',
            dt_3: item.queuingNum ? item.queuingNum : '暂无数据',
        }, {
            key: item.status,
            color: item.status === '预约成功' ? 'lv' : item.status === '预约中' ? 'hei' : 'hui',
            dt_1: item.projectName,
            dt_2: item.houseName,
            dt_3: item.reserveTime ? moment(item.reserveTime).format('LL') : '暂无数据',
        }, {
            key: item.billStatus === '0' ? '未缴费' : '已缴费',
            color: item.billStatus === '待支付' ? 'lv' : 'hong',
            dt_1: item.projectName,
            dt_2: item.houseNo,
            dt_3: item.billAmount ? item.billAmount : '暂无数据',
        }, {
            key: contractStatus(Number(item.contractStatus)),
            color: item.contractStatus === '21' || item.contractStatus === '2' ? 'lv' : 'hui',
            dt_1: item.house !== undefined ? item.house.projectName : '暂无',
            dt_2: item.house !== undefined ? item.house.houseNo : '暂无',
            dt_3: item.contractAttribute === '01' || item.contractAttribute === '03' ? '个人' : '单位',
        }]
        const { visible, confirmLoading, tapIndex, isMaterial, jzhImages, loadingss, jzzImages, sbImages } = this.state
        return (
            <div style={{ width: '100%' }} key={index}>
                <Col span={24} className="setNone">
                    {this.state.sonObj.son == '0' ?
                        <Card title={item.title} bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                            <Row>
                                <Col span={4} style={{ borderRight: '1px solid #DCE5FF', textAlign: 'center', lineHeight: '100px', fontSize: '26px' }} className={dt_4[currest].color}>
                                    <span>{dt_4[currest].key}</span>
                                </Col>
                                <Col span={12} style={{ borderRight: '1px solid #DCE5FF' }}>
                                    <Row style={{ fontSize: '16px', textAlign: 'center', padding: '21px 10px' }} gutter={[0, 8]}>
                                        <Col span={8} className='hui'>{dt_1[currest]}</Col>
                                        <Col span={8} className='hui'>{dt_2[currest]}</Col>
                                        <Col span={8} className='hui'>{dt_3[currest]}</Col>
                                        <Col span={8} className='hei'>{dt_4[currest].dt_1}</Col>
                                        <Col span={8} className='hei'>{dt_4[currest].dt_2}</Col>
                                        <Col span={8} className='hei'>{dt_4[currest].dt_3}</Col>
                                    </Row>
                                </Col>
                                <Col span={8} style={{ textAlign: 'center', lineHeight: '100px' }}>
                                    {/* <div><a href="/#">查看详情</a></div> */}
                                    {currest == '1' ? (item.status == '排队中') || (item.status == '排队成功' && item.reserveStatus == '') ? <div>
                                        <Popconfirm
                                            title="取消排队将重新进行排队,是否确认取消?"
                                            onConfirm={() => { tapOnce(this.handleOk, item.id) }}
                                            onCancel={() => { this.handleCancels() }}
                                            visible={visible}
                                            okButtonProps={{ loading: confirmLoading }}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <a href="#" onClick={() => { this.showPopconfirm() }}>取消排队</a>
                                        </Popconfirm>
                                        {item.status == '排队成功' && item.reserveStatus == '' ?
                                            <a onClick={() => {
                                                let p = { projectName: item.projectName, projectNo: item.projectNo }
                                                tapOnce(this.getProjectDetail, p)

                                            }}>&nbsp;预约看房</a> : null}
                                    </div> : null : null}
                                    {currest == '2' ? item.status == '预约中' ? <div>
                                        <Popconfirm
                                            title="取消预约视为您放弃本套房源及取消您目前的排队状态，如需选择其他房源，需重新排队轮候，请谨慎操作。"
                                            onConfirm={() => { tapOnce(this.cancelReserve, item.id) }}
                                            onCancel={() => { this.handleCancels() }}
                                            visible={visible}
                                            okButtonProps={{ loading: confirmLoading }}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <a href="#" onClick={() => { this.showPopconfirm() }}>取消预约</a>
                                        </Popconfirm>
                                    </div> : null : null}
                                    {currest == '4' ? <div><a onClick={() => { tapOnce(this.showContractInfo, item.contractNo) }}>查看详情</a></div> : null}
                                    {currest == '0' ?
                                        <div>
                                            <a onClick={() => { tapOnce(this.showApply, item.id) }}>查看详情</a>
                                            {item.checkStatus == '驳回' ? <a onClick={() => {
                                                this.getTransactionDetailByIds(item.id)
                                            }}><Divider type="vertical" />修改</a> : null}
                                            {item.progress == '成功' ? <a href={item.addition} style={{ marginLeft: '10px' }} target='_blank'>下载</a> :
                                                null}
                                            {(item.progress == '已复核' || item.progress == '已上传' || item.progress == '成功') && item.checkStatus != '驳回' ?
                                                <a onClick={() => { tapOnce(this.printTransaction, item) }} style={{ marginLeft: '10px' }}>打印</a> :
                                                null}
                                            {(item.lackMaterialsFlag == '1' || item.lackMaterialsFlag == '2' || item.lackMaterialsFlag == '3') && item.smsCount > 0 && item.progress != '失败' ? <a onClick={() => { tapOnce(this.showMaterialMakeupBox, item) }} style={{ marginLeft: '10px' }} target='_blank'>补材料</a> :
                                                null}
                                        </div> :
                                        null}
                                </Col>
                            </Row>
                        </Card> : null}
                </Col>
                <Col span={24} className="setBlock" style={{ display: 'none' }}>
                    {this.state.sonObj.son == '0' ?
                        <Card bordered={false} bodyStyle={{ width: '100%', boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)', marginTop: '20px', padding: '0 24px 50px 24px' }}
                        >
                            <Row>
                                <Col span={24} style={{ lineHeight: '2em', fontSize: '20px' }} className={dt_4[currest].color}>
                                    <span>{dt_4[currest].key}</span>

                                </Col>
                                <Col span={24}>
                                    <Row>
                                        <Col span={9} className='hui'>
                                            {dt_1[currest]}
                                        </Col>
                                        <Col span={15} >
                                            {dt_4[currest].dt_1}
                                        </Col>
                                        <Col span={9} className='hui'>
                                            {dt_2[currest]}
                                        </Col>
                                        <Col span={15} >
                                            {dt_4[currest].dt_2}
                                        </Col>
                                        <Col span={9} className='hui'>
                                            {dt_3[currest]}
                                        </Col>
                                        <Col span={15} >
                                            {dt_4[currest].dt_3}
                                        </Col>
                                        {item.transactionNoTitle ?
                                            <Col span={9} className='hui'>
                                                {item.transactionNoTitle}
                                            </Col> : null}
                                        {item.transactionNoTitle ?
                                            <Col span={15} >
                                                {item.transactionNo}
                                            </Col> : null}
                                        {item.copeWithTitle ?
                                            <Col span={9} className='hui'>
                                                {item.copeWithTitle}
                                            </Col> : null}
                                        {item.copeWithTitle ?
                                            <Col span={15} >
                                                {item.copeWith}
                                            </Col> : null}
                                        {item.contractNoTitle ?
                                            <Col span={9} className='hui'>
                                                {item.contractNoTitle}
                                            </Col> : null}
                                        {item.contractNoTitle ?
                                            <Col span={15} >
                                                {item.contractNo}
                                            </Col> : null}
                                        <Col span={9} className='hui'>
                                            {item.timesTitle}
                                        </Col>
                                        <Col span={15}>
                                            {item.times}
                                        </Col>
                                        {currest == '0' ? <Row className='cardBottom'>
                                            <Col style={{ borderLeft: '0px solid #C9D6FF' }}>
                                                <a onClick={() => { tapOnce(this.showApply, item.id) }}>查看详情</a>
                                            </Col>
                                            {item.checkStatus == '驳回' ? <Col><a onClick={() => {
                                                this.getTransactionDetailByIds(item.id)
                                            }}><Divider type="vertical" />修改</a> </Col> : null}
                                            {item.progress == '成功' ? <Col > <a href={item.addition} style={{ marginLeft: '10px' }} target='_blank'>下载</a></Col> :
                                                null}
                                            {(item.progress == '已复核' || item.progress == '已上传' || item.progress == '成功') && item.checkStatus != '驳回' ?
                                                <Col ><a onClick={() => { this.printTransaction(item) }} style={{ marginLeft: '10px' }}>打印</a> </Col> :
                                                null}
                                            {(item.lackMaterialsFlag == '1' || item.lackMaterialsFlag == '2' || item.lackMaterialsFlag == '3') && item.smsCount > 0 && item.progress != '失败' ? <Col> <a onClick={() => { tapOnce(this.showMaterialMakeupBox, item) }} style={{ marginLeft: '10px' }} target='_blank'>补材料</a></Col> :
                                                null}
                                        </Row> : null}
                                        {currest == '1' ? (item.status == '排队中') || (item.status == '排队成功' && item.reserveStatus == '') ? <Row className='cardBottom'>
                                            <Popconfirm
                                                title="取消排队将重新进行排队,是否确认取消?"
                                                onConfirm={() => { tapOnce(this.handleOk, item.id) }}
                                                onCancel={() => { this.handleCancels() }}
                                                visible={visible}
                                                okButtonProps={{ loading: confirmLoading }}
                                                okText="确定"
                                                cancelText="取消"
                                            >
                                                <a href="#" onClick={() => { this.showPopconfirm() }} style={{ lineHeight: '40px' }}>取消排队</a>

                                            </Popconfirm>
                                            {item.status == '排队成功' && item.reserveStatus == '' ?
                                                <a onClick={() => {
                                                    let p = { projectName: item.projectName, projectNo: item.projectNo }
                                                    tapOnce(this.getProjectDetail, p)
                                                }}>&nbsp;预约看房</a> : null}

                                        </Row> : null : null}
                                        {currest == '2' ? item.status == '预约中' ? <div className='cardBottom'>
                                            <Popconfirm
                                                title="取消预约视为您放弃本套房源及取消您目前的排队状态，如需选择其他房源，需重新排队轮候，请谨慎操作。"
                                                onConfirm={() => { tapOnce(this.cancelReserve, item.id) }}
                                                onCancel={() => { this.handleCancels() }}
                                                visible={visible}
                                                okButtonProps={{ loading: confirmLoading }}
                                                okText="确定"
                                                cancelText="取消"
                                            >
                                                <a href="#" onClick={() => { this.showPopconfirm() }} style={{ lineHeight: '40px' }}>取消预约</a>
                                            </Popconfirm>
                                        </div> : null : null}
                                        {currest == '4' ? <div className='cardBottom'><a style={{ lineHeight: '40px' }} onClick={() => { this.showContractInfo(item.contractNo) }}>查看详情</a></div> : null}
                                    </Row>
                                </Col>
                            </Row>
                        </Card> : null}
                </Col>
                {/*<Modal title="补全材料" visible={isMaterial} onCancel={() => { this.handleCancel() }} onOk={() => { this.repairMaterials() }} className="personalModal">*/}
                {/*    <div style={{ backgroundColor: '#fcf8e3' }}>*/}
                {/*        <h3>驳回原因：</h3>*/}
                {/*        <p dangerouslySetInnerHTML={{ __html: this.state.lackMaterialsReason ? this.state.lackMaterialsReason : '' }}></p>*/}
                {/*    </div>*/}
                {/*    {item.lackMaterialsFlag == '1' || item.lackMaterialsFlag == '3' ?*/}
                {/*        <div>*/}
                {/*            <span>主申请人居住证（若为单位整体租赁，须上传单位承诺书，格式为jpg或者png）</span>*/}
                {/*            {loadingss ? <CommonUploads serrArr={jzzImages} setCommonImages={this.setCommonImages} list={{ kind: '居住证', transactionAdditionType: '主申请人附件' }} /> : null}*/}
                {/*        </div> :*/}
                {/*        null}*/}
                {/*    {item.lackMaterialsFlag == '2' || item.lackMaterialsFlag == '3' ?*/}
                {/*        <div>*/}
                {/*            <span>社保缴纳证明（格式为jpg或者png）</span>*/}
                {/*            {loadingss ? <CommonUploads serrArr={sbImages} setCommonImages={this.setCommonImages} list={{ kind: '社保缴纳证明', transactionAdditionType: '主申请人附件' }} /> : null}*/}
                {/*        </div> :*/}
                {/*        null}*/}
                {/*</Modal>*/}
            </div>
        );
    }
    //收藏  收藏功能未完成
    collect = (item, index) => {
        return (
            <Col span={24} key={index}>
                <Card title={item.title} bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                    <Row>
                        {/* <Col span={4} style={{ borderRight: '1px solid #DCE5FF', textAlign: 'center', lineHeight: '100px', fontSize: '26px' }} className={dt_4[currest].color}>
                            <span>{dt_4[currest].key}</span>
                        </Col> */}
                        <Col span={12} style={{ borderRight: '1px solid #DCE5FF' }}>
                            <Row style={{ fontSize: '16px', textAlign: 'center', padding: '21px 10px' }} gutter={[0, 8]}>
                                {/* <Col span={8} className='hui'>{dt_1[currest]}</Col>
                                <Col span={8} className='hui'>{dt_2[currest]}</Col>
                                <Col span={8} className='hui'>{dt_3[currest]}</Col>
                                <Col span={8} className='hei'>{dt_4[currest].dt_1}</Col>
                                <Col span={8} className='hei'>{dt_4[currest].dt_2}</Col>
                                <Col span={8} className='hei'>{dt_4[currest].dt_3}</Col> */}
                            </Row>
                        </Col>
                        <Col span={8} style={{ textAlign: 'center', lineHeight: '100px' }}>
                            <div><a href="/#">查看详情</a></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        );
    }

    //站内信
    message = (item, index) => {
        return (

            <Col span={24} key={index}>
                <Card title={item.title} className='setNone' bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                    <Row>

                        <Col span={18} >
                            {item.content}
                        </Col>
                        <Col span={6} style={{ textAlign: 'center', lineHeight: '30px', padding: '20px' }}>
                            <div className={'hui'} style={{ border: '1px solid #eee', borderRadius: '5px' }}>{moment(item.createTime).format('LL')}</div>
                        </Col>
                    </Row>
                </Card>
                <Card title={item.title} className='setBlock ' bordered={false} bodyStyle={{ width: '100%', boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)', marginTop: '20px', padding: '0 24px 10px 24px' }}>
                    <Row>

                        <Col span={24} style={{ paddingBottom: '5px' }}>
                            {item.content}
                        </Col>
                        <Col span={24} >
                            <div className={'hui'} >{moment(item.createTime).format('YYYY-MM-DD')}</div>
                        </Col>
                    </Row>
                </Card>

            </Col>
        );
    }

    edit = (e) => {
        this.setState({
            isedit: true
        })
    }
    handleCancel = () => {
        this.setState({
            isModalVisible: false,
            isChangePassword: false,
            isChangeMobile: false,
            isMaterial: false,
            jzzImages: '',
            jzzImagesTmp: '',
            sbImages: '',
            sbImagesTmp: '',
            lackMaterialsFlag: ''
        })
    }
    sendNationCaptcha = async () => {
        const { isTap } = this.state
        if (this.refs.formRef.getFieldValue('mobile') && this.refs.formRef.getFieldValue('mobile') !== undefined) {
            if (isTap === false) {
                this.setState({ isTap: true })
                let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
                if (!reg_tel.test(this.refs.formRef.getFieldValue('mobile'))) {

                    return
                }
                let opts = {}
                opts.mobile = this.refs.formRef.getFieldValue('mobile')
                let data = await sendNationCaptcha(opts)
                if (data?.code != 0) {
                    message.error(data?.message)
                } else {
                    this.timersBtn()
                }

            } else {
                message.error('请勿重复点击')
            }
        } else {
            message.error('请填写您的手机号码')
        }



    }
    getUpdateUser = async () => {
        if (this.refs.formRef.getFieldValue('mobile') && this.refs.formRef.getFieldValue('mobile') != undefined) {
            let reg_tel = /^[1][3,4,5,7,8,9][0-9]{9}$/
            if (!reg_tel.test(this.refs.formRef.getFieldValue('mobile'))) {
                message.error('请输入正确手机号')
                return
            }
            let opts = {}
            opts.mobile = this.refs.formRef.getFieldValue('mobile')
            opts.idno = this.props.userLoginInfo.idno;
            opts.username = this.props.userLoginInfo.username;
            opts.email = this.props.userLoginInfo.email;
            let data = await getUpdateUser(opts)
            console.log(data);
            if (data.code === 0) {
                message.success('修改手机号成功')
                let Info = JSON.parse(JSON.stringify(this.props.userLoginInfo))
                Info.mobile = opts.mobile
                this.props.saveLoginInfo(Info)
                this.getMyTransactionList('6')
            } else {
                message.error('修改手机号失败')
            }
        } else {
            message.error('请填写您的手机号码')
        }
        this.setState({
            isChangeMobile: false,
            isedit: false
        })
    }
    timersBtn = () => {
        this.timers = setInterval(() => {
            this.setState({
                timer: this.state.timer - 1
            })
            if (this.state.timer === 0) {
                clearInterval(this.timers)
                this.setState({
                    isTap: false,
                    timer: 60
                })
            }
        }, 1000)
    }
    ChangeMobile = () => {
        this.setState({
            isChangeMobile: true
        })
    }
    changePassword = () => {
        console.log(1);
        this.setState({
            isModalVisible: false,
            isChangePassword: true
        })
    }
    //个人资料
    personalMessage = (item, index) => {
        const { isedit } = this.state
        return (

            <Col span={24} key={index}>
                <Row className={'marginBottom-20'}>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>用户头像</Col>
                    <Col xs={12} sm={16} md={16} lg={16} xl={16}>
                        <Avatar
                            shape="square"
                            size={{ xs: 32, sm: 40, md: 64, lg: 64, xl: 80, xxl: 100 }}
                            icon={<AntDesignOutlined />}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>
                        <div className={'lan'} onClick={this.edit} style={{ border: '1px solid #1890ff', borderRadius: '5px', textAlign: 'center' }}>编辑资料</div>
                    </Col>
                </Row>
                <Row className={'marginBottom-20'}>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>用户姓名</Col>
                    <Col span={16}>
                        {item.username}
                    </Col>
                </Row>
                <Row className={'marginBottom-20'}>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>身份证号</Col>
                    <Col span={16}>
                        {item.idno}
                    </Col>

                </Row>
                <Row className={'marginBottom-20'}>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>手机号码</Col>
                    <Col span={16}>
                        <a style={{ marginRight: '20px' }}>{item.mobile}</a>
                        {isedit === true ? <a onClick={this.ChangeMobile}>修改手机号</a> : ''}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={4} md={4} lg={4} xl={4}>账号密码</Col>
                    <Col span={16}>
                        <a style={{ marginRight: '20px' }}>******</a>
                        <a onClick={this.changePassword}>修改密码</a>
                    </Col>
                </Row>
            </Col>
        );
    }
    personalPush = (tab) => {
        this.setState({
            selectableTab: tab
        })
        this.getMyTransactionList('')
    }
    render() {
        const { userLoginInfo } = this.props
        // const { transactionList, currest } = this.state
        const { selectableTab, transactionList, currest, needFixed, isModalVisible, loading, personal, loginLoading, signView, timer, isChangePassword, isChangeMobile, sonObj, loadings, lackMaterialsFlag, jzzImages, jzzImagesTmp, loadingss, isMaterial, sbImages, sbImagesTmp } = this.state
        console.log("🚀 ~ file: index.js:1064 ~ Personal ~ render ~ lackMaterialsFlag:", lackMaterialsFlag)
        
        const lists = [
            '我的申请',
            '我的排队',
            '我的预约',
            '我的账单',
            '我的合同',
            // '我的收藏',
            '消息通知',
            '个人资料'
        ]
        return (
            <div id='personal'>
                <Top personalPush={this.personalPush} />
                <div className='content' style={{ display: 'inline-block', width: '100%', marginTop: '6em' }}>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <div style={{ paddingLeft: '7px', marginBottom: '1.8em' }} className='setNone'>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>个人中心</Breadcrumb.Item>
                                <Breadcrumb.Item>{lists[currest]}</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className='setBlock' style={{ display: 'none', fontWeight: 'bold', fontSize: '22px', lineHeight: '3em' }}>
                            {lists[currest]}
                        </div>
                        <Layout style={{ background: '#f9f9f9' }}>
                            <Lefter userLoginInfo={userLoginInfo} selectable={selectableTab ? selectableTab : '0'} getMyTransactionList={(e) => { tapOnce(this.getMyTransactionList, e, 500) }} />
                            <Content style={{ margin: '0 16px', background: '#fff' }}>
                                <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                                    <div className="site-card-wrapper">
                                        {/* 右侧展示内容 */}
                                        {currest < 5 ? <Row gutter={[0, 24]}>
                                            {currest == '0' && sonObj.son == '2' ?
                                                <div>
                                                    {loadings ?
                                                        <Spin /> :
                                                        <Row gutter={[0, 24]}>
                                                            {sonObj.transactionDetail ? <Card bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                                                                <Row>
                                                                    <Col>
                                                                        <Apply toson={this.state.sonObj} getChangeSons={this.getChangeSons} />
                                                                    </Col>
                                                                </Row>
                                                            </Card> : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                                        </Row>}
                                                </div> : ''}
                                            {currest == '4' && sonObj.son == '1' ?
                                                <div>
                                                    {loadings ?
                                                        <Spin /> :
                                                        <Row gutter={[0, 24]}>
                                                            {sonObj.contractInfos ? <Card bordered={true} style={{ border: '1px solid #A0B5FB' }} headStyle={{ borderBottom: '1px solid #A0B5FB', padding: '0 24px', background: '#F3F6FF', color: '#999999', fontSize: '16px' }}>
                                                                <Row>
                                                                    <Col>
                                                                        <ContractInfo toson={this.state.sonObj} getChangeSon={this.getChangeSon} />
                                                                    </Col>
                                                                </Row>
                                                            </Card> : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                                        </Row>
                                                    }
                                                </div> : ''}
                                            {currest === '3' ? <Col span={24}>
                                                <Tabs defaultActiveKey="0" centered onChange={(e) => { tapOnce(this.callback, e, 1000) }}>
                                                    <TabPane tab="未缴费" key="0"></TabPane>
                                                    <TabPane tab="已缴费" key="1"></TabPane>

                                                </Tabs>
                                            </Col> : ''}
                                            {transactionList.length > 0 ? transactionList.map(this.tableBody) : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                        </Row> : ''}
                                        {/* {currest === '5' ? <Row gutter={[0, 24]}>
                                            {transactionList.length > 0 ? transactionList.map(this.collect) : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                        </Row> : ''} */}
                                        {currest === '5' ? <Row gutter={[0, 24]}>
                                            {transactionList.length > 0 ? transactionList.map(this.message) : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                        </Row> : ''}
                                        {currest === '6' ? <Row gutter={[0, 24]}>
                                            {transactionList.length > 0 ? transactionList.map(this.personalMessage) : <Col span={24}><Empty style={{ height: '545px' }} /></Col>}
                                        </Row> : ''}
                                    </div>
                                </div>
                            </Content>
                        </Layout>
                    </div>
                    <div className="col-lg-2"></div>
                </div>
                <Footer />
                <Modal title="补全材料" visible={isMaterial} onCancel={() => { this.handleCancel() }} onOk={() => { tapOnce(this.repairMaterials) }} className="personalModal">
                    <div style={{ backgroundColor: '#fcf8e3' }}>
                        <h3>驳回原因：</h3>
                        <p dangerouslySetInnerHTML={{ __html: this.state.lackMaterialsReason ? this.state.lackMaterialsReason : '' }}></p>
                    </div>
                    {lackMaterialsFlag == '1' || lackMaterialsFlag == '3' ?
                        <div>
                            <span>主申请人居住证（若为单位整体租赁，须上传单位承诺书，格式为jpg或者png）</span>
                            {loadingss ? <CommonUploads serrArr={jzzImages} serrArrTmp={jzzImagesTmp} setCommonImages={this.setCommonImages} list={{ kind: '居住证', transactionAdditionType: '主申请人附件', type: '补材料' }} /> : null}
                        </div> :
                        null}
                    {lackMaterialsFlag == '2' || lackMaterialsFlag == '3' ?
                        <div>
                            <span>社保缴纳证明（格式为jpg或者png）</span>
                            {loadingss ? <CommonUploads serrArr={sbImages} serrArrTmp={sbImagesTmp} setCommonImages={this.setCommonImages} list={{ kind: '社保缴纳证明', transactionAdditionType: '主申请人附件', type: '补材料' }} /> : null}
                        </div> :
                        null}
                </Modal>
                <Modal title={"修改密码"} visible={isChangePassword} onCancel={() => { this.handleCancel() }} footer={[]} width={492} style={{ padding: '23px' }}>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={(e) => { tapOnce(this.setPassword, e) }}
                        ref={'formRef'}
                        autoComplete="off"
                    >
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="mobile" rules={[{ required: true, message: '未输入手机号码!' }, { validator: this.testValidate }]}>
                                    <Input placeholder="手机号码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 9, offset: 3 }} lg={{ span: 13, push: 3, offset: 0 }}>
                                <Form.Item label="" name="research" rules={[{ required: true, message: '请填写验证码!' }]}>
                                    <Input placeholder="验证码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 9, offset: 2 }} lg={{ span: 6, offset: 0 }}>
                                {timer === 60 ? <Button style={{ width: '100%', height: '40px' }} onClick={() => { tapOnce(this.sendNationCaptcha) }}>获取验证码</Button>
                                    : <Button style={{ width: '100%', height: '40px' }} disabled={true}>{timer} S</Button>}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="loginPwd" rules={[{ required: true, message: '请填写新密码!' }, { validator: this.testValidate }]}>
                                    <Input.Password placeholder="新密码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item style={{ textAlign: 'center', lineHeight: '2em' }}>
                                    <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', height: '48px', fontSize: '15px' }}>
                                        重设密码
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <Modal title={"修改手机号"} visible={isChangeMobile} onCancel={() => { this.handleCancel() }} footer={[]} width={492} style={{ padding: '23px' }}>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={(e) => { tapOnce(this.getUpdateUser, e, 500) }}
                        ref={'formRef'}
                        autoComplete="off"
                    >
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="mobile" rules={[{ required: true, message: '未输入手机号码!' }, { validator: this.testValidate }]}>
                                    <Input placeholder="手机号码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item style={{ textAlign: 'center', lineHeight: '2em' }}>
                                    <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', height: '48px', fontSize: '15px' }}>
                                        确认
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </div>

        )
    }
    testValidate = (rule, value, callback) => {
        if (rule.field === 'mobile') {
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (!reg_tel.test(value)) {
                return callback('请填写有效手机号码');
            }
        }
        if (rule.field === 'username') {
            let reg_tel = /[A-Za-z0-9_\-\u4e00-\u9fa5]+/
            if (!reg_tel.test(value)) {
                return callback('请输入中文、英文、数字');
            }
        }
        if (rule.field === 'loginPwd') {
            let reg_tel = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%^&*?\(\)]).*$/
            if (!reg_tel.test(value)) {
                return callback('密码长度至少8位，至少1个大写字母、1个小写字母、1个数字和1个特殊字符!');
            }
        }
        if (rule.field === 'loginUser') {
            if (!value) {
                return callback('请填写证件号码');
            }
            let arr = []
            let flag = false
            arr.push(idCardValid(value).status)
            // arr.push(isHKCard(value).status)
            arr.push(isTWCard(value).status)
            arr.push(isPassPortCard(value).status)
            // arr.push(isOfficerCard(value).status)
            // arr.push(isAccountCard(value).status)
            if (arr.indexOf(1) == -1) {
                flag = true
            }
            if (flag == true) {
                return callback('证件号码不合规');
            }
        }
        return Promise.resolve();

    }
}

const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Personal)
